import { Modal, Button } from '@efast_public/fjd-component-library';
import { VermerkDto } from '../../api/models/Vermerk/VermerkDto';

interface HintModalProps {
  readonly onClose: () => void;
  readonly isOpen: boolean;
  readonly onDelete: (vermerk: VermerkDto) => void;
  readonly vermerk: VermerkDto;
}

export function DeleteVermerkConfirmationModal({
  onClose,
  isOpen,
  onDelete,
  vermerk
}: HintModalProps) {
  return (
    <Modal
      appElement={document.querySelector('.fjd-base-layout') as HTMLElement}
      closeOnBackdropClick={false}
      open={isOpen}
      onClose={onClose}
    >
      <Modal.Header id="DeleteVermerkConfirmationModal-header">
        Vermerk löschen
      </Modal.Header>
      <Modal.Content>
        <div id={'delete_vermerk_hint'}>
          Möchten Sie diesen Vermerk wirklich endgültig löschen?
        </div>
      </Modal.Content>
      <Modal.Footer>
        <Button variant="secondary-outline" onClick={onClose}>
          Abbrechen
        </Button>
        <Button variant="primary" onClick={() => onDelete(vermerk)}>
          Vermerk löschen
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default DeleteVermerkConfirmationModal;
